import { render, staticRenderFns } from "./Apagon.vue?vue&type=template&id=4b32eec2&scoped=true"
import script from "./Apagon.vue?vue&type=script&lang=js"
export * from "./Apagon.vue?vue&type=script&lang=js"
import style0 from "./Apagon.vue?vue&type=style&index=0&id=4b32eec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b32eec2",
  null
  
)

export default component.exports